import { render, staticRenderFns } from "./AddonsListItemBreakdown.vue?vue&type=template&id=b75b4b9a&scoped=true&"
import script from "./AddonsListItemBreakdown.vue?vue&type=script&lang=js&"
export * from "./AddonsListItemBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./AddonsListItemBreakdown.vue?vue&type=style&index=0&id=b75b4b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75b4b9a",
  null
  
)

export default component.exports